import React from 'react';
import PropTypes from 'prop-types';
import { confirmable, createConfirmation } from 'react-confirm';

import BasicButton from 'components/BasicButton';
import BasicButtonGroup from 'components/BasicButtonGroup';
import Popup from 'components/Popup';

import { UxHelpers } from 'helpers/ux-helpers.js';
import { DateHelpers } from 'helpers/date-helpers';

import './styles.css';

const ShortlistActivityDialog = props => {
  const {
    show,
    proceed,
    dismiss,
    data,
    CandidateName,
    modeless,
    hasCloseButton,
    popupStyles,
  } = props;

  const proceedHandler = () => {
    proceed();
    UxHelpers.overflowLock('unlock');
  };

  const dismissHandler = () => {
    dismiss();
    UxHelpers.overflowLock('unlock');
  };

  const bodyRender = (
    <div>
      <p className="shortlist-activity-dialog--title">{`${CandidateName} was added to:`}</p>
      {data.map((r, i) => (
        <div className="shortlist-activity-dialog--row" key={i}>
          {`${r.ShortlistName} ${
            r.Date ? 'on ' + DateHelpers.getMonthNameDayYearFormat(r.Date) : ''
          } by ${r.RecruiterName ? r.RecruiterName : 'your team member'}`}
        </div>
      ))}
    </div>
  );

  const buttons = (
    <BasicButtonGroup
      groupStyles={{
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <BasicButton
        controlFunc={proceedHandler}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText="Go to Shortlist"
      />
      <BasicButton
        controlFunc={dismissHandler}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText="Stay here"
      />
    </BasicButtonGroup>
  );

  return (
    show && (
      <Popup
        actions={{ dismiss }}
        buttonsRender={buttons}
        popupStyles={popupStyles}
        bodyRender={bodyRender}
        modeless={modeless}
        dismissWhenClose={true}
        hasCloseButton={hasCloseButton}
      />
    )
  );
};

ShortlistActivityDialog.propTypes = {
  CandidateName: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      ShortlistID: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      ShortlistName: PropTypes.string,
      RecruiterName: PropTypes.string,
      Date: PropTypes.string,
    })
  ).isRequired,
  modeless: PropTypes.bool,
};

export default createConfirmation(confirmable(ShortlistActivityDialog));
